import { render, staticRenderFns } from "./schjLX.vue?vue&type=template&id=2030e811&scoped=true&"
import script from "./schjLX.vue?vue&type=script&lang=js&"
export * from "./schjLX.vue?vue&type=script&lang=js&"
import style0 from "./schjLX.vue?vue&type=style&index=0&id=2030e811&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030e811",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2030e811')) {
      api.createRecord('2030e811', component.options)
    } else {
      api.reload('2030e811', component.options)
    }
    module.hot.accept("./schjLX.vue?vue&type=template&id=2030e811&scoped=true&", function () {
      api.rerender('2030e811', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schj/schjLX.vue"
export default component.exports